<template>
  <div>
    <h2 class="c-title c-title--page">{{$t('results')}}</h2>
    <main class="o-row">
      <div class="c-row" v-for="category in categories" :key="category.id">
        <h3 class="c-title c-title--event u-padding-left-small">
          {{category.name}}
        </h3>

        <div v-for="group in getRankings(category)" :key="`${category.id}-${group.rankingType}`"
             class="o-layout u-margin-bottom-medium">
          <div class="c-button--group c-button--group__huge o-layout__item u-push-none u-1-of-1">
            <router-link v-for="ranking in group.rankings" :key="ranking.id"
              class="c-button c-button--huge c-button--primary"
              :to="{ name: 'cis.ranking', params: { categoryId: category.id, rankingId: ranking.id}}">
              {{getRankingTitle(ranking, category)}}
            </router-link>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import find from 'lodash/find';
  import map from 'lodash/map';

  import rankingLib from 'client/lib/ranking.js';
  import rounds from 'client/lib/rounds'
  import filter from "lodash/filter";

  export default {
    name: "rankings",
    data: function() {
      return {
        categories: [],
        round: null,
      };
    },
    computed: {
      discipline: function() {
        return this.$store.state.eventDiscipline.discipline;
      },
      session: function() {
        return find(this.$store.state.sessions.items, item => {
          return item.id === this.$route.params.sessionId;
        });
      },
      rankings: function() {
        return this.$store.state.rankings.items
      }
    },
    created: function() {
      this.categories = map(this.session.categories, sessionCategory => {
        return find(this.$store.state.categories.items, item => {
          return sessionCategory.categoryId === item.id;
        });
      });
      this.round = rounds.getRound(this.session.roundIndex)
    },
    methods: {
      getRankings: function(category) {
        const rankings = rankingLib.sortRankings(filter(this.rankings, r => r.categoryId === category.id))
        const groups = []
        rankings.forEach(ranking => {
          let group = groups.find(g => g.rankingType === ranking.rankingType)
          if (! group) {
            group = {
              rankingType: ranking.rankingType,
              rankings: []
            }
            groups.push(group)
          }
          group.rankings.push(ranking)
        })

        return groups
      },
      getRankingTitle: function(ranking, category) {
        return rankingLib.getTitle(ranking, category, this.round)
      }
    },
  }
</script>

<style scoped>

</style>
